<template>
    <div>
        <el-radio-group v-model="humanSide" fill="#833e93" text-color="#ffffff" size="small">
            <el-radio-button label="Front"></el-radio-button>
            <el-radio-button label="Body"></el-radio-button>
        </el-radio-group>

        <div class="human-map-wrapper">
            <span :class="humanSideLowerCase + '_left'">LEFT</span>
            <span :class="humanSideLowerCase + '_right'">RIGHT</span>
            <div key="body">
                <body_f
                    v-if="humanSide === 'Front' && !isFrontAllPartsSelected"
                    :key="selectedParts.length"
                    color="#B2B2B2"
                    class="body_f">
                </body_f>
                <body_f_selected
                    v-if="humanSide === 'Front' && isFrontAllPartsSelected"
                    :key="selectedParts.length"
                    class="body_f">
                </body_f_selected>
                <body_b
                    v-if="humanSide === 'Body' && !isBackAllPartsSelected"
                    :key="selectedParts.length"
                    color="#B2B2B2"
                    class="body_b">
                </body_b>
                <body_b_selected
                    v-if="humanSide === 'Body' && isBackAllPartsSelected"
                    :key="selectedParts.length"
                    class="body_b">
                </body_b_selected>
            </div>
            <div v-for="bodyPart in humanMap" :key="bodyPart.id">
                <template v-if="bodyPart.side.toLowerCase() === humanSideLowerCase">
                    <div class="tooltip" v-if="selectedParts.filter(bp => bp.id === bodyPart.id).length">
                        <span :ref="bodyPart.id + '_tooltip'" class="tooltiptext">{{ bodyPart.tooltip }}</span>
                    </div>
                    <div 
                        :is="bodyPart.id === 'head' ? 'head_map' : bodyPart.id" 
                        :ref="bodyPart.id"
                        :key="selectedParts.length" 
                        :class="bodyPart.id"  
                        @click.native="toggle(bodyPart.id)" 
                        :color="selectedParts.filter(bp => bp.id === bodyPart.id).length ? '#833E93' : '#CCCCCC'">
                    </div>
                </template>
            </div>
        </div>
        <div class="selected-text">
            <span v-if="calcSelectedList['Front'].length" style="margin-top: 20px; ">Front<br>
                <span v-for="part in calcSelectedList['Front']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
            <br><br>
            <span v-if="calcSelectedList['Body'].length" style="margin-top: 10px;">Body<br>
                <span v-for="part in calcSelectedList['Body']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { RadioGroup, RadioButton } from 'element-ui'
    import SubQuestion from './index'
    import IconComponents from '../icon/Swelling/components'

    Vue.use(RadioGroup)
    Vue.use(RadioButton)

    const humanMap = [
        { id: 'around_right_eye', side: 'Front', tooltip: 'Around Right Eye' },
        { id: 'around_left_eye', side: 'Front', tooltip: 'Around Left Eye' },
        { id: 'right_cheekbone', side: 'Front', tooltip: 'Right Cheekbone' },
        { id: 'left_cheekbone', side: 'Front', tooltip: 'Left Cheekbone' },
        { id: 'right_jaw', side: 'Front', tooltip: 'Right Jaw' },
        { id: 'left_jaw', side: 'Front', tooltip: 'Left Jaw' },
        
        { id: 'face', side: 'Body', tooltip: 'Face' },
        { id: 'neck', side: 'Body', tooltip: 'Neck' },
        { id: 'right_armpit', side: 'Body', tooltip: 'Right Armpit' }, 
        { id: 'right_breast', side: 'Body', tooltip: 'Right Breast' }, 
        { id: 'left_armpit', side: 'Body', tooltip: 'Left Armpit' },
        { id: 'left_breast', side: 'Body', tooltip: 'Left Breast' },
        { id: 'upper_abdomen', side: 'Body', tooltip: 'Upper Abdomen' },
        { id: 'lower_abdomen', side: 'Body', tooltip: 'Lower Abdomen' },
        { id: 'groin_area', side: 'Body', tooltip: 'Groin Area' },
        { id: 'right_arm', side: 'Body', tooltip: 'Right Arm' },
        { id: 'left_arm', side: 'Body', tooltip: 'Left Arm' },
        { id: 'right_hand_fingers', side: 'Body', tooltip: 'Right hand Fingers' },
        { id: 'left_hand_fingers', side: 'Body', tooltip: 'Left hand Fingers' },
        { id: 'right_leg_calf', side: 'Body', tooltip: 'Right Leg/Calf' },
        { id: 'left_leg_calf', side: 'Body', tooltip: 'Left Leg/Calf' },
        { id: 'right_foot', side: 'Body', tooltip: 'Right Foot' },
        { id: 'left_foot', side: 'Body', tooltip: 'Left Foot' },
        { id: 'lips_mouth', side: 'Front', tooltip: 'Lips/Mouth' },
        { id: 'tongue', side: 'Front', tooltip: 'Tongue' },
    ]

    export default {
        name: 'knee',
        extends: SubQuestion,
        watch: {
            humanSide: function() {
                this.$nextTick(() => this.removeTooltips())
                this.$emit('changeHumanMapSide', this.humanSide)
            }
        },

        props: {
            saved: {
                type: Array
            }
        },

        data() {
            return {
                humanMap: JSON.parse(JSON.stringify(humanMap)),
                humanSide: 'Front',
                selectedParts: [] || this.saved,
                unsortedBodyParts: [] || this.saved,
                frontTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Front"),
                backTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Body"),
                normalizeHumanMap: JSON.parse(JSON.stringify(humanMap)).reduce((acc,ele) => {
                    return { ...acc, [ele.id]: { ...ele }}
                }, {})
            }
        },

        mounted() {
            this.loadData()
            this.$emit('changeHumanMapSide', this.humanSide)
        },

        methods: {
            /**
             * @func placeTooltip
             * @desc places tooltip on body part selection
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            placeTooltip(bodyPart) {
                let imgRef = this.$refs[bodyPart][0].$el
                let tooltipRef = this.$refs[bodyPart + '_tooltip'][0]
                tooltipRef.style.visibility = 'visible'

                let top = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('top').replace('px', ''))
                let left = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('left').replace('px', ''))

                tooltipRef.style.top = (top + 80) + 'px'
                // for body parts on right side of the screen
                if ((this.humanSide === 'Front' && bodyPart.includes('left')) || (this.humanSide === 'Body' && bodyPart.includes('right'))) {
                    tooltipRef.style.left = (left - 30) + 'px'
                }
                // for body parts on left side of the screen
                else if ((this.humanSide === 'Front' && bodyPart.includes('right')) || (this.humanSide === 'Body' && bodyPart.includes('left'))) {
                    tooltipRef.style.left = (left - 80) + 'px'
                }
                // for head
                else if(bodyPart.includes('head') || bodyPart.includes('neck') || bodyPart.includes('throat') || bodyPart.includes('knee') || bodyPart.includes('abdomen')) {
                    tooltipRef.style.top = (top + 50) + 'px'
                    tooltipRef.style.left = (left) + 'px'
                }
                // for middle body parts
                else tooltipRef.style.left = (left + 10) + 'px'
            },
            /**
             * @func removeTooltips
             * @desc removes all tooltips
             * @param tooltipText(String)
             */
            removeTooltips(tooltipText) {
                if (document.getElementsByClassName('tooltiptext')) {
                    let classes = document.getElementsByClassName('tooltiptext')
                    Object.keys(classes).forEach(cls => {
                        if (!tooltipText || (tooltipText && classes[cls].innerHTML.trim() === tooltipText))
                            classes[cls].style.visibility = 'hidden'
                    })
                }
            },
            loadData() {
                if (!this.saved) this.$emit('selectbp', [])
                else {
                    this.unsortedBodyParts = this.saved
                    this.selectedParts = this.saved
                    this.sortBodyParts()
                    this.$emit('selectbp', this.saved)
                }
                this.$nextTick(() => this.removeTooltips())
            },
            /**
             * @func toggle
             * @desc toggles the state of body part
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            toggle(bodyPart) {
                // making inactive
                if (this.selectedParts.filter(bp => bp.id === bodyPart).length) {
                    this.selectedParts = this.selectedParts.filter(part => part.id !== bodyPart)
                    this.unsortedBodyParts = this.unsortedBodyParts.filter(part => part.id !== bodyPart)
                }
                // making active
                else {
                    if (this.limitReached(this.humanSide)) 
                        return

                    let tooltipText = ''
                    let reqObj = {
                        id: bodyPart,
                        value: bodyPart
                    }

                    this.selectedParts.push(reqObj)
                    this.unsortedBodyParts.push(reqObj)

                    tooltipText = this.humanMap.filter(bp => bp.id === bodyPart)[0].tooltip
                    // placing tooltip on top of the body part
                    this.$nextTick(() => this.placeTooltip(bodyPart))
                    // remove tooltip after 1.5seconds
                    setTimeout(() => this.removeTooltips(tooltipText), 1500)
                }
                // sort
                this.sortBodyParts()
                this.$emit('selectbp', this.selectedParts)
            },
            sortBodyParts() {
                let tempSelectedParts = []
                this.humanMap.forEach(bp => {
                    this.selectedParts.forEach(sp => {
                        if (sp.value === bp.id) tempSelectedParts.push(sp)
                    })
                })
                this.selectedParts = tempSelectedParts
            },
        },

        computed: {
            humanSideLowerCase() {
                return this.humanSide.toLowerCase()
            },
            calcSelectedList() {
                let selectedList = { 'Front': [], 'Body': [], 'Side': [] }
                this.unsortedBodyParts.forEach(part => {
                    let partObj = this.humanMap.filter(bodyPart => part.value === bodyPart.id)[0]
                    selectedList[partObj.side].push(partObj.tooltip)
                })
                return selectedList
            },
            isFrontAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Front").length === this.frontTotalParts.length
            },
            isBackAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Body").length === this.backTotalParts.length
            }
        },

        components: {
            ...IconComponents
        },
    }
</script>

<style lang="scss" scoped>
    $choice-size: 150px;
    $choice-font-size: 20px;
    @import "style.scss";

    .body_f {
        position: absolute;
        top: 111px;
        left: 86px;
    }
    .body_b {
        position: absolute;
        top: 100px;
        left: 30px;
    }

    .around_right_eye {
        position: absolute;
        top: 208px;
        left: 125px;
    }

    .around_left_eye {
        position: absolute;
        top: 208px;
        right: 86px;
    }

    .right_cheekbone {
        position: absolute;
        top: 230px;
        left: 130px;
    }

    .left_cheekbone {
        position: absolute;
        top: 230px;
        right: 94px;
    }

    .right_jaw {
        position: absolute;
        top: 260px;
        left: 125px;
    }

    .left_jaw {
        position: absolute;
        top: 260px;
        right: 88px;
    }

    .face {
        position: absolute;
        top: 105px;
        left: 151px;
    }

    .tongue {
        position: absolute;
        top: 295px;
        left: 165px;
    }

    .lips_mouth {
        position: absolute;
        top: 275px;
        left: 155px;
    }

    .neck {
        position: absolute;
        top: 187px;
        left: 158px;
    }

    .right_armpit {
        position: absolute;
        top: 240px;
        left: 109px;
    }

    .right_breast {
        position: absolute;
        top: 237px;
        left: 127px;
    }

    .left_armpit {
        position: absolute;
        top: 240px;
        right: 88px;
    }

    .left_breast {
        position: absolute;
        top: 237px;
        right: 106px;
    }

    .upper_abdomen {
        position: absolute;
        top: 295px;
        left: 133px;
    }

    .lower_abdomen {
        position: absolute;
        top: 335px;
        left: 133px;
    }

    .groin_area {
        position: absolute;
        top: 384px;
        left: 141px;
    }

    .right_arm {
        position: absolute;
        top: 280px;
        left: 64px;
    }

    .left_arm {
        position: absolute;
        top: 280px;
        right: 43px;
    }

    .right_hand_fingers {
        position: absolute;
        top: 406px;
        left: 29px;
    }

    .left_hand_fingers {
        position: absolute;
        top: 406px;
        right: 9px;
    }

    .right_leg_calf {
        position: absolute;
        top: 445px;
        left: 117px;
    }

    .left_leg_calf {
        position: absolute;
        top: 445px;
        right: 95px;
    }

    .right_foot {
        position: absolute;
        top: 660px;
        left: 120px;
    }

    .left_foot {
        position: absolute;
        top: 660px;
        right: 100px;
    }
</style>
